import { render, staticRenderFns } from "./RiskConfigEvaluationPreview.vue?vue&type=template&id=230ccb6b"
import script from "./RiskConfigEvaluationPreview.vue?vue&type=script&lang=js"
export * from "./RiskConfigEvaluationPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports